import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { of, Observable, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CommunicationsService {

  constructor(private _http: HttpClient) { }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetUserMessagesInfo(strUserID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/communication/getusermessagelist?UserId=' + strUserID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  GetUserNotificationsInfo(strUserID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/communication/getusernotificationlist?UserId=' + strUserID + '', null, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  AddUpdateMessageInfo(megInfo: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/communication/managemessageinfo/', megInfo, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }


  //THIS IS SERVICE FOR GET ALL STATES LIST
  AddUpdateServiceMessageInfo(megInfo: any): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };

    return this._http.post(environment.apiUrl + 'api/communication/manageservicemessageinfo/', megInfo, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }

  //THIS IS SERVICE FOR GET ALL STATES LIST
  SubmitSubscripsion(emaiID: string): Observable<any> {
    var httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    };
    var data = {
      "EmailID": emaiID
    }

    return this._http.post(environment.apiUrl + 'api/user/subscribe', data, httpOptions).pipe(
      tap(null,
        () => {
          // An error has occurred, so increment this request's ERROR_COUNT.
        }),
      // Retry the request a configurable number of times.
      retry(2),
      catchError(this.handleError)
    );
  }



  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(error);
  }

  //THIS IS THE FUNCATION FOR CONVERT TO LOCAL(YYYY-MM-DD) DATE FORMAT BY GIVEN DATE FORMAT
  private ConvertToDate(strD: any): string {
    return new Date(new Date(strD).getFullYear(), new Date(strD).getMonth(), ((new Date(strD).getDate()) + 1)).toISOString().slice(0, 10);
  }
}
